<template>
  <div>
    <div class="mains" v-if="loading" v-loading="loading" element-loading-spinner="el-icon-loading"></div>
    <div v-else>
      <div class="man-title">
        巡视点管理
        <el-button @click="add" class="btn" type="primary" size="mini" :disabled="roleId == 2 || roleId == 3 || roleId == 4">新增巡视点</el-button>
        <span v-if="roleId == 2 || roleId == 3 || roleId == 4"></span>
        <a href="/device/wapi/v1/file/patrol/excel/export" target="_blank" v-else><el-button class="btn" style="margin-right: 10px" type="primary" size="mini">导出表格</el-button></a>
      </div>
      <div class="search">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="所属部门">
            <el-select size="small" v-model="formInline.departmentId" clearable placeholder="请选择所属部门">
              <el-option
                v-for="item in bumen"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="位置">
            <el-select  size="small" v-model="formInline.facilityId" clearable placeholder="请选择位置">
              <el-option
                v-for="item in sheshi"
                :label="item.name"
                :value="item.id"
                :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建人">
            <el-select size="small" v-model="formInline.staffId" clearable placeholder="请选择创建人">
              <el-option
                v-for="item in yuangong"
                :label="item.name"
                :value="item.id"
                :key="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="small" type="primary" @click="onSubmit"
              >查询</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="list-box">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column prop="patrolName" label="巡视点名称"></el-table-column>
          <el-table-column prop="departmentName" label="所属部门"></el-table-column>
          <el-table-column prop="facilityName" label="设施位置"></el-table-column>
          <el-table-column prop="deviceCount" label="设备数量"></el-table-column>
          <el-table-column prop="checkItemCount" label="检查项"></el-table-column>
          <el-table-column prop="creator" label="创建人"></el-table-column>
          <el-table-column prop="createTime" label="创建日期">
            <template slot-scope="scope">
              {{ scope.row.createTime ? dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss'):'' }}
            </template>
          </el-table-column>
          <el-table-column prop="qrcodeUrl" label="二维码">
            <template slot-scope="scope">
              <!-- <img :src="scope.row.qrcodeUrl" width="60"> -->
              <el-image 
                style="width: 100px; height: 100px"
                :src="scope.row.qrcodeUrl"
                :preview-src-list="[scope.row.qrcodeUrl]"
                >
              </el-image>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-dropdown placement="bottom-start" trigger="click">
                <span @click.stop="">
                  <span class="el-dropdown-link">
                    操作<i class="el-icon-arrow-down"></i>
                  </span>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item><div @click="details(scope.row)">详情</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 2 || roleId == 3 || roleId == 4"><div @click="edit(scope.row)">编辑</div></el-dropdown-item>
                  <el-dropdown-item :disabled="roleId == 2 || roleId == 3 || roleId == 4"><div @click="dlt(scope.row)">删除</div></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <page v-if="total!==0" :size="size" :page="page" :total="total" v-on:sizeChange="sizeChange" v-on:pageChange="pageChange"></page>
      </div>
    </div>
  </div>
</template>

<script>
import page from '@/components/page.vue'
import dayjs from 'dayjs';
export default {
  components: {
    page
  },
  data() {
    return {
      loading: false,
      size: 50,
      page: 1,
      total: 0,
      form: {},
      rules: {},
      dialogTitle: "",
      dialogVisible: false,
      tableData: [],
      formInline: {},
      position: [],
      positionFilter: [],
      departmentTreeData: [],
      defaultProps: {
        children: "childTree",
        label: "name",
      },
      radio: {},
      bumen: [],
      sheshi: [],
      yuangong: [],
      roleId: 0
    };
  },
  methods: {
    dayjs,
    details(row) {
      this.$router.push({ name: 'patrolDetail', params: {row: row}})
    },
    departmentChange(id) {
      this.form.positionIdList = "";

      function filterFun(item) {
        return item.departmentId == id;
      }
      this.positionFilter = this.position.filter(filterFun);
    },
    edit(row) {
      this.$router.push({ name: 'patrolEdit', params: {row: row} })
    },
    dlt(row) {
      this.$confirm("确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$ajax.post("patrolDelete", {
          id: row.id,
        }).then((res) => {
          this.loadList();
        });
      });
    },
    ok() {
      if (this.dialogTitle == "新增") {
        this.$ajax.post("staffCreate", this.form).then((res) => {
          this.dialogVisible = false;
          this.loadList();
        });
      } else {
        this.$ajax.post("staffUpdate", this.form).then((res) => {
          this.dialogVisible = false;
          this.loadList();
        });
      }
    },
    add() {
      this.$router.push({ name: 'patrolAdd' })
    },
    onSubmit() {
      this.page = 1
      sessionStorage.setItem('currentPage', 1)
      this.loadList()
    },
    loadList() {
      this.loading = true
      this.$ajax.post("patrolList", {
        departmentId: this.formInline.departmentId?this.formInline.departmentId:null,
        facilityId: this.formInline.facilityId?this.formInline.facilityId:null,
        staffId: this.formInline.staffId?this.formInline.staffId:null,
        pageNum: this.page,
        pageSize: this.size
      }).then((res) => {
        this.tableData = res.data;
        this.total = res.total
        this.loading = false
      }).catch(err=>{
        this.loading = false
      })
    },
    loadDepartmentList() {
      this.$ajax.get("departmentTree").then((res) => {
        this.departmentTreeData = res.data;
      });
    },
    loadPositionList() {
      this.$ajax.get("positionQueryAll").then((res) => {
        this.position = this.getTreeData(res.data);
      });
    },
    getTreeData(data) {
      let arr = [];
      if (Array.isArray(data)) {
        let sss = (d) => {
          d.forEach((item, index) => {
            arr.push({
              id: item.id,
              name: item.name,
              departmentId: item.departmentId,
            });
            if (item.childTree.length > 0) {
              sss(item.childTree);
            }
          });
        };
        sss(data);
      }
      return arr;
    },
    load_sheshi() {
      this.$ajax.get("facilityQueryAll").then((res) => {
        this.sheshi = res.data;
      });
    },
    load_yuangong() {
      this.$ajax.get("staffDueryAll").then((res) => {
        this.yuangong = res.data;
      });
    },
    load_bumen() {
      this.$ajax.get("departmentTree").then((res) => {
        this.bumen = this.getTreeData(res.data);
      });
    },
    pageChange(val) {
      this.page = val
      sessionStorage.setItem('currentPage', val)
      this.loadList()
    },
    sizeChange(val) {
      this.size = val
      sessionStorage.setItem('currentSize', val)
      this.loadList()
    },
    getLastPage() {
      this.page = Number(sessionStorage.getItem('currentPage')) || 1
    },
    getSize() {
      this.size = Number(sessionStorage.getItem('currentSize')) || 50
    },
  },
  mounted() {
    this.getLastPage()
    this.getSize()
    this.loadList();
    this.load_bumen();
    this.load_sheshi();
    this.load_yuangong();
    this.roleId = sessionStorage.getItem('r')
  },
  destroyed() {
    // sessionStorage.removeItem('currentPage')
    // sessionStorage.removeItem('currentSize')
  }
};
</script>

<style lang="less" scoped>
.mains {
  padding: 400px 0;
  height: 100%;
}
/deep/.el-loading-spinner .el-icon-loading{
  font-size: 50px;
}
.btn {
  float: right;
}
</style>